export default __webpack_public_path__ + "static/media/master_card.edf29108.svg";